function Library_form_collection(element) {
    this.$element = $(element);

    this.selectors = {
	    elementDocument: '.js-element-document',
	    fieldTitle: '.js-field-title',
	    hiddenUploadedFile: '.js-hidden-uploaded-file',
	    hiddenChoosedFile: '.js-hidden-choosed-file'
    };
    
    this.triggers = {
	    validate: 'i4:validate'
    };
    
    this.data = {
	    name: 'name'
    };
    
    this.init = function() {
	    this.$elementDocument = this.$element.find(this.selectors.elementDocument);
	    this.$fieldTitle = this.$element.find(this.selectors.fieldTitle);
	    this.$hiddenUploadedFile = this.$element.find(this.selectors.hiddenUploadedFile);
	    this.$hiddenChoosedFile = this.$element.find(this.selectors.hiddenChoosedFile);
	    
	    this.dataName = this.$element.data(this.data.name);
	    
	    this.$elementDocument.on('i4:change i4:choose', this.$onChangeDocument.bind(this)); 
    };
    
    this.$onChangeDocument = function() {	    
    
    	if (
    		(this.$hiddenUploadedFile.length && this.$hiddenUploadedFile.val() !== "") || 
    		(this.$hiddenChoosedFile.length && this.$hiddenChoosedFile.val() !== "")
    	) {
			this.$fieldTitle.attr('data-required', 1);
		} else {
			this.$fieldTitle.attr('data-required', 0);
		}    
		
		this.$fieldTitle.trigger(this.triggers.validate);
    };
}
